<template>
  <div
    id="main-carousel"
    class="carousel slide carousel-fade font-weight-bold text-uppercase"
    role="region"
    aria-roledescription="karuzela"
    aria-label="Usługi warsztatu"
    @mouseenter="pause"
    @mouseleave="resume"
    @focusin="pause"
    @focusout="resume"
    @keydown.left.prevent="previous"
    @keydown.right.prevent="next"
    @touchstart.passive="touchStart = $event.changedTouches[0].clientX"
    @touchend.passive="swipe"
  >
    <div class="carousel-inner">
      <div
        class="carousel-item"
        :class="{ active: activeSlide === 0 }"
        :aria-hidden="activeSlide !== 0"
      >
        <img
          class="d-block w-100"
          src="@/assets/images/mazda6.jpg"
          alt="Warsztat blacharsko - lakierniczy"
        />
        <div class="carousel-caption">
          <h3>
            Warsztat<br />
            <span class="text-primary">blacharsko</span><br />
            lakierniczy
          </h3>
        </div>
      </div>

      <div
        class="carousel-item"
        :class="{ active: activeSlide === 1 }"
        :aria-hidden="activeSlide !== 1"
      >
        <img
          class="d-block w-100"
          src="@/assets/images/honda.jpg"
          alt="Kompleksowe naprawy bezgotówkowe"
        />
        <div class="carousel-caption">
          <h3>
            Kompleksowe<br />
            <span class="text-primary">naprawy</span><br />
            bezgotówkowe
          </h3>
        </div>
      </div>

      <div
        class="carousel-item"
        :class="{ active: activeSlide === 2 }"
        :aria-hidden="activeSlide !== 2"
      >
        <img
          class="d-block w-100"
          src="@/assets/images/garage.jpg"
          alt="Pełna obsługa powypadkowa"
        />
        <div class="carousel-caption">
          <h3>
            Pełna<br />
            <span class="text-primary">obsługa</span><br />
            powypadkowa
          </h3>
        </div>
      </div>
    </div>

    <button
      class="carousel-control-prev"
      type="button"
      aria-controls="main-carousel"
      aria-label="Poprzedni slajd"
      @click="previous"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      aria-controls="main-carousel"
      aria-label="Następny slajd"
      @click="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';

export default defineComponent({
  name: 'main-carousel',
  setup() {
    const activeSlide = ref(0);
    const touchStart = ref(0);
    let timer: ReturnType<typeof setInterval> | undefined;

    const next = () => {
      activeSlide.value = (activeSlide.value + 1) % 3;
    };
    const previous = () => {
      activeSlide.value = (activeSlide.value + 2) % 3;
    };
    const pause = () => {
      clearInterval(timer);
    };
    const resume = () => {
      pause();
      timer = setInterval(() => {
        if (!document.hidden) next();
      }, 5000);
    };
    const swipe = (event: TouchEvent) => {
      const distance = event.changedTouches[0].clientX - touchStart.value;
      if (distance < -50) next();
      if (distance > 50) previous();
    };

    onMounted(resume);
    onBeforeUnmount(pause);

    return { activeSlide, touchStart, next, previous, pause, resume, swipe };
  },
});
</script>

<style lang="scss" scoped>
.carousel-item {
  display: block;
}
</style>
